export default "__VITE_ASSET__D80qSK5P__"